import { SET_AUDIO_MUSIC, SET_SCROLL_ACTIVE_AUDIO } from './constants'

export const setScrollActiveAction = payload => ({ type: SET_SCROLL_ACTIVE_AUDIO, payload })
export const setPlayAudioAction = payload => ({ type: SET_AUDIO_MUSIC, payload })

export const setAudioData = data => dispatch => dispatch(setPlayAudioAction(data))
export const setScrollActive = data => dispatch => dispatch(setScrollActiveAction(data))
